import styled from "styled-components";
import { designTokens } from "../../ui/foundation/DesignTokens";

// Same full-width bar under the nav as SuscriptionAlert, aligned with the
// iVentas Design System v4.0 "Alertas" section: a border in the severity's own
// tone, and text on step 700 of each ramp — the first step that passes WCAG AA
// (4.5:1) on its 50 background: error 5.91:1, warning 4.84:1 (step 600 gave
// 4.41:1 and 3.07:1).

const tone = (type, step, fallback) => {
  const ramp = designTokens.colors[type];
  return type === "error" || type === "warning" ? ramp[step] : fallback;
};

// 360 y Meta pueden estar caídos a la vez, así que el contenedor apila. Es él
// quien ocupa el área del grid; las barras van dentro para no competir por la
// misma celda (dos elementos en un mismo grid-area se solapan).
export const Stack = styled.div`
  grid-area: incident;
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const Bar = styled.div`
  display: flex;
  align-items: center;
  padding: ${designTokens.spacing.sm} ${designTokens.spacing.xl};
  height: fit-content;
  z-index: 1;
  border-bottom: 1px solid ${({ type }) => tone(type, 200, designTokens.colors.gray[200])};
  background-color: ${({ type }) => tone(type, 50, "white")};

  /* Phones (360–390 px): 16 px side gutter so the text keeps its width. */
  @media (max-width: 600px) {
    padding: ${designTokens.spacing.sm} ${designTokens.spacing.lg};
  }
`;

export const MessageWrapper = styled.p`
  display: flex;
  gap: ${designTokens.spacing.sm};
  align-items: flex-start;
  min-width: 0;
  margin: 0;
  font-size: ${designTokens.fontSizes.sm};
  font-family: ${designTokens.fonts.body};
  line-height: 1.45;
  overflow-wrap: anywhere;
  color: ${({ type }) => tone(type, 700, designTokens.colors.gray[900])};

  /* The icon sits on the first line and never shrinks when the text wraps. */
  svg {
    flex-shrink: 0;
    margin-top: 1px;
  }
`;
